import { render } from "./CreateAnnouncement.vue?vue&type=template&id=17220136&scoped=true"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=js"

import "./CreateAnnouncement.vue?vue&type=style&index=0&id=17220136&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17220136"]])

export default __exports__